import { Trans } from '@lingui/react'
import classNames from 'clsx'
import { bool, node, number, string } from 'prop-types'
import { uriQueryInDoubleQuotedAttr } from 'xss-filters'

import { AD_SERVER_CROSS_SELL_MORE_LINK } from 'shared/consts/adServer'
import { withI18n } from 'shared/utils/withI18n'
import IconArrowRight from 'views/components/atoms/Icon/IconArrowRight'
import IconCircleInfo from 'views/components/atoms/Icon/IconCircleInfo'
import ButtonTooltip from 'views/components/molecules/ButtonTooltip'
import LinkWithIcon from 'views/components/molecules/LinkWithIcon'
import { i18nType } from 'views/utils/propTypes'
import setInnerHTML from 'views/utils/setInnerHTML'

const SliderHeader = ({
  title,
  titleIsHtml,
  headerTag: HeaderComponent,
  className,
  moreLinkUrl,
  moreLinkTitle,
  target,
  isSponsored,
  i18n,
  wid,
}) => {
  const titleClassName = classNames('o-SliderHeader u-no-margin', {
    'u-margin--right': moreLinkUrl,
    'l-flex__fill-gap@medium': !isSponsored && moreLinkUrl,
  })

  const getHeader = () => {
    if (titleIsHtml && title) {
      return (
        <HeaderComponent className={titleClassName} {...setInnerHTML(title)} />
      )
    }
    if (title) {
      return (
        <HeaderComponent className={titleClassName}>{title}</HeaderComponent>
      )
    }
    return <div className={titleClassName}>{'\u00A0'}</div>
  }

  return (
    <div
      className={classNames(
        'o-SliderHorizontal__header l-flex l-flex--wrap l-flex--distribute-space u-padding--bottom',
        className
      )}
      data-clientside-hook="slider__header"
    >
      {getHeader()}
      {isSponsored && (
        <div className="l-flex__grow-one">
          <ButtonTooltip
            name="sponsored-tooltip"
            id={`sponsored-tooltip-${wid}`}
            sideRendered="right"
            text={i18n._('general.label.sponsored')}
            inline
          >
            <IconCircleInfo size="small" />
          </ButtonTooltip>
        </div>
      )}
      {moreLinkUrl && (
        <LinkWithIcon
          href={uriQueryInDoubleQuotedAttr(decodeURIComponent(moreLinkUrl))}
          target={target}
          icon={<IconArrowRight />}
          data-clientside-hook={AD_SERVER_CROSS_SELL_MORE_LINK}
          right
        >
          <span className="u-font-weight--bold o-SliderHeader__link-text o-SliderHorizontal__SliderHeader__title">
            {moreLinkTitle || <Trans id="general.label.ShowAllProducts" />}
          </span>
        </LinkWithIcon>
      )}
    </div>
  )
}
SliderHeader.propTypes = {
  title: string,
  titleIsHtml: bool,
  isSponsored: bool,
  moreLinkTitle: node,
  moreLinkUrl: string,
  className: string,
  target: string,
  headerTag: string,
  i18n: i18nType.isRequired,
  wid: number,
}

SliderHeader.defaultProps = {
  title: null,
  titleIsHtml: false,
  isSponsored: false,
  moreLinkTitle: null,
  moreLinkUrl: null,
  target: null,
  className: null,
  headerTag: 'h2',
  wid: null,
}

export default withI18n()(SliderHeader)
